import { buildOrganizationApiUrl } from "../../configuration";
import { http } from "../../http";

export const getCarriersAndOperatorsHubFeatures = (
  organizationIds: string[]
): Promise<GeoJSON.Feature<GeoJSON.Geometry>[]> => {
  return http.post(
    buildOrganizationApiUrl(`/organizations/getCarriersAndOperatorsHubFeatures`),
    JSON.stringify(organizationIds),
  );
};
